import React, { useState, useCallback } from "react";
import { Trans } from "@lingui/react/macro";
import {
  BackgroundColor,
  Button,
  SectionContainer
} from "@silversea-ssc/ui-components-react";
import {
  FormDisclaimerFragment,
  PageBuilderBrochureLeadFormFragment,
  PageBuilderBrochureLeadForm_BrochureFragment
} from "types/graphql-types";
import BrochureStickyBar from "components/BrochureStickyBar/BrochureStickyBar";
import { isPresent } from "src/utils/checks";

const NewRequestBrochureModal = React.lazy(
  () => import("components/RequestBrochureModal/RequestBrochureModal")
);

type BrochureLeadFormAsModalProps = {
  heading: PageBuilderBrochureLeadFormFragment["heading"];
  brochure: PageBuilderBrochureLeadForm_BrochureFragment | undefined;
  backgroundColor: BackgroundColor | "titaniumDark";
  openInNewPage: boolean;
  thankYouPageURL: string | undefined;
  dataContentName?: string;
  ctaLabel?: string;
  dataPageBuilderAnchor?: string;
  formDisclaimerContent: FormDisclaimerFragment | undefined;
};
const BrochureLeadFormAsSticky: React.FC<
  React.PropsWithChildren<BrochureLeadFormAsModalProps>
> = ({
  heading,
  brochure,
  openInNewPage,
  thankYouPageURL,
  dataContentName,
  backgroundColor,
  children,
  ctaLabel,
  dataPageBuilderAnchor,
  formDisclaimerContent
}) => {
  const [showModal, setShowModal] = useState(false);
  const openBrochureModal = useCallback(() => setShowModal(true), []);
  const closeModal = useCallback(() => setShowModal(false), []);

  const ctaButton = (
    <Button
      onClick={openBrochureModal}
      renderAs="button"
      mobileSize="small"
      variant="accent"
      dataContentPiece="view_brochure_online"
      iconName="brochure"
    >
      {isPresent(ctaLabel) ? (
        ctaLabel
      ) : (
        <Trans id="cta-request-single-brochure">Request a brochure</Trans>
      )}
    </Button>
  );

  return (
    <React.Fragment>
      <BrochureStickyBar
        image={brochure?.thumbnail}
        content={heading?.content?.localized}
        ctaButton={ctaButton}
        dataContentName={dataContentName}
        backgroundColor={backgroundColor}
      >
        <SectionContainer
          backgroundColor={backgroundColor}
          spacingTop={undefined}
          spacingBottom="compact"
          id={dataPageBuilderAnchor}
        >
          {children}
        </SectionContainer>
      </BrochureStickyBar>

      {showModal && thankYouPageURL && brochure && (
        <React.Suspense>
          <NewRequestBrochureModal
            isOpen={true}
            onRequestClose={closeModal}
            brochure={brochure}
            thankYouStragegy={openInNewPage ? "newPage" : "redirect"}
            thankYouPageURL={thankYouPageURL}
            formDisclaimerContent={formDisclaimerContent}
          />
        </React.Suspense>
      )}
    </React.Fragment>
  );
};

export default BrochureLeadFormAsSticky;
